import "./FooterStyles.css";

import React from "react";

import { FaHome, FaPhone, FaMailBulk, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";


const Footer = () => {
  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <div className="location">
                    <FaHome size={20} style={{color: "#fff", marginRight: "1rem"}} />
                    <div>
                        <p>Cavite</p>
                        <p>Philippines</p>
                    </div>
                </div>
                <div className="phone">
                    <h4>
                    <FaPhone size={20} style={{color: "#fff", marginRight: "1rem"}} />
                    0917-112-9593
                    </h4>
                </div>
                <div className="email">
                    <h4>
                    <FaMailBulk size={20} style={{color: "#fff", marginRight: "1rem"}} />
                    miaka.dev@gmail.com
                    </h4>
                </div>
            </div>

            <div className="right">
                <h4>Something about me</h4>
                <p> I’m an aspiring web developer passionate about creating clean, user-friendly websites using modern tools like React. I enjoy turning ideas into interactive web experiences and constantly look for ways to improve my skills. My goal is to grow into a full-stack developer and build meaningful digital solutions.</p>
                <div className="social">
                    <FaFacebook size={30} style={{color: "#fff", marginRight: "1rem"}} />
                    <FaTwitter size={30} style={{color: "#fff", marginRight: "1rem"}} />
                    <FaLinkedin size={30} style={{color: "#fff", marginRight: "1rem"}} />

                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer